import { render } from "./topicView.vue?vue&type=template&id=0176e0a4"
import script from "./topicView.vue?vue&type=script&lang=js"
export * from "./topicView.vue?vue&type=script&lang=js"

import "./topicView.vue?vue&type=style&index=0&id=0176e0a4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__